import { FunctionComponent, useState } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

interface ITextInputWithRegisterProps {
    id: string;
    placeholder: string;
    register: UseFormRegisterReturn;
    label?: string;
    value?: string;
    containerStyles?: string;
    labelStyles?: string;
    password?: boolean;
    showPasswordToggle?: boolean;
    testId?: string;
    dataCyId?: string;
    error?: any;
    name?: string;
}

const TextInputWithRegister: FunctionComponent<ITextInputWithRegisterProps> = ({
    label,
    id,
    placeholder,
    containerStyles,
    labelStyles,
    password,
    showPasswordToggle = false,
    testId,
    dataCyId,
    register,
    error,
}) => {
    const [passwordVisible, setPasswordVisible] = useState(false);

    const name = id;
    
    const inputType = password 
        ? (passwordVisible ? 'text' : 'password') 
        : 'text';
    
    const togglePasswordVisibility = (e: React.MouseEvent) => {
        e.preventDefault();
        setPasswordVisible(!passwordVisible);
    };
    
    return (
        <div className={`${containerStyles}`}>
            {
                label && (
                    <label className={`block text-gray-700 text-sm font-bold mb-2 ${labelStyles}`}>
                        {label}
                    </label>
                )
            }
            {(password && error) && (
                <div className='text-danger mb-4'>
                    <p>Password Must:</p>
                    <p>Be a minimum of 8 characters</p>
                    <p>Contain at least 1 uppercase letter (A,B,C,D)</p>
                    <p>Contain at least 1 lowercase letter (a,b,c,d)</p>
                    <p>Contain at least 1 special character (!,@,#,$)</p>
                    <p>Contain at least 1 number (1,2,3,4)</p>
                </div>
            )}
            <div className="relative">
                <input
                    className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:border-primary mb-2'
                    id={id}
                    type={inputType}
                    placeholder={placeholder}
                    data-testid={testId}
                    data-cy={dataCyId}
                    {...register}
                />
                {password && showPasswordToggle && (
                    <button
                        type="button"
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 mb-2"
                        onClick={togglePasswordVisibility}
                        aria-label={passwordVisible ? "Hide password" : "Show password"}
                    >
                        <img 
                            src={passwordVisible ? "/images/closed_eye.png" : "/images/open_eye.png"} 
                            alt={passwordVisible ? "Hide password" : "Show password"}
                            className="w-5 h-5 mb-4"
                        />
                    </button>
                )}
            </div>
            {error && <p className='text-sm text-red-600 mb-3'>{ `${error}` }</p>}
        </div>
    )
};

export default TextInputWithRegister;
